/**
 * Mixin for looking after generic multi option filters
 */
import { find, orderBy } from "lodash";

export default {
	data() {
		return {
			searchText: "",
			selected: [],
			type: "item",
			sortBy: ["name"]
		};
	},
	methods: {
		matched(search, item) {
			return item.name.toLowerCase().includes(search);
		}
	},
	computed: {
		items() {
			return [];
		},
		label() {
			const length = this.selected.length;
			return length
				? `${length} ${this.type}${length === 1 ? "" : "s"} `
				: `All ${this.type}s`;
		},
		filtered() {
			let items = this.items;
			const search = this.searchText.toLowerCase();
			if (search) {
				items = items.filter((u) => this.matched(search, u));
			}
			return orderBy(items, this.sortBy);
		},
		isFiltered() {
			return !(this.searchText !== "");
		},
		showSearch() {
			return this.items.length > 5;
		},
		noItems() {
			return !this.items.length;
		},
		noMatch() {
			return !this.filtered.length;
		}
	}
};
